import * as React from "react";
import TimeList from "./TimeList";
import EditTime from "./EditTime";
import { addTime } from "actions/timeType.action";
import EventType from "components/Setting/EventType";

const TimeTypes = (props) => {
  return (
    <EventType
      open={props.open}
      close={props.close}
      apiAddFunc={addTime}
      buttonLabel="Time Types"
      listComponent={TimeList}
      editFormComponent={EditTime}
      component="timeTypes"
    />
  );
};

export default TimeTypes;
